import { Ordering, PaginationConfig } from '@wix/comments-ooi-client/controller';
import { CommentsOrdering } from '../../types';
import { CommentsOrderingMap } from '../../constants/comments-pagination-config';

export const getCommentsPaginationConfig = (
  commentLimit: number,
  commentsOrdering?: CommentsOrdering,
): PaginationConfig => {
  return {
    replyShowMoreLimit: 2,
    ordering: CommentsOrderingMap[commentsOrdering!] || Ordering.NEWEST_FIRST,
    initialPage: {
      commentLimit,
      replyLimit: 0,
    },
    pagination: {
      commentLimit: 5,
      replyLimit: 5,
    },
    maxPagesBeforeDrop: {
      commentPages: 5,
      replyPages: 4,
    },
  };
};
